import { render } from "./FeeModalSectionDetails.vue?vue&type=template&id=161f530c"
import script from "./FeeModalSectionDetails.vue?vue&type=script&lang=js"
export * from "./FeeModalSectionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__